<template>
  <div class="header-wrap">
    <header>
      <div class="header-left">
        <img src="./../../assets/hr_login_white.png" class="img">
      </div>
      <div class="header-right">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            {{ this.orgInfo.orgName|limitWords(10)
                        }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-office-building" @click.native="tootherindex">企业中心</el-dropdown-item>
            <el-dropdown-item @click.native="logout" icon="el-icon-switch-button">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    <div class="area">
      <div class="list">
        <div class="list-head">
          产品列表
        </div>
        <div class="list-box">
          <div class="list-item" v-for=" item in productList" :key="item.id" @click="linkto(item.url)">
            <img :src="item.image" class="img">
            <span class="name">{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie';

import list1 from '@/assets/list1.png';
import list2 from '@/assets/list2.png';
import list3 from '@/assets/list3.png';
import list4 from '@/assets/list4.png';

export default {
  created () {
    this.getUserInfo()
  },
  data () {
    return {
      userInfo: [],
      orgInfo: [],
      productList:[
      {name:'悦享工资条',id:'1',url:'/index/new',image:list1},
      {name:'悦享心语',id:'2',url:'/lovecardindex/template',image:list2},
      {name:'短信中心',id:'3',url:'/smsindex/smspackage',image:list3},
      {name:'悦享问卷',id:'4',url:'',image:list4},
      ]
    }
  },
  methods: {
    linkto (path) {
      if(path){
        this.$router.push(path)
      }else{
        this.$notify({
          title: '失败',
          message: '该板块正在建设中...',
          type: 'error',
        }) 
      }
    },
    getUserInfo () {
      this.$http.get('authority-center/common/user/info').then((res) => {
        this.orgInfo = res.data
        this.$http.get(`authority-center/org/${res.data.orgId}`).then((res) => {
          this.userInfo = res.data
        })
      })
    },
 
    tootherindex () {
      // window.location.href = 'http://ucenter.prosuntech.com/#/enterpriseIndex';
      window.location.href = 'https://ucenter.joyousoa.com/#/enterpriseIndex';
    },
    logout () {
      window.sessionStorage.removeItem('token')
      Cookie.remove('token', { path: '/', domain: '192.168.18.199' });
      Cookie.remove("token", { path: "/", domain: ".prosuntech.com" });
      Cookie.remove('token', { path: '/', domain: '.joyousoa.com' });
      this.$router.push('/login')
      window.location.reload()
    },
  },
}
</script>

<style lang="less" scoped>
.header-wrap {
  header {
    height: 60px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    background: #377CFD;
    background: #377CFD;
    padding: 30px;

    .header-left {
      display: flex;
      align-items: center;
      justify-content: left;

      .img {
        width: 135px;
      }

    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: left;

      .el-dropdown-link {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        line-height: 24px;
      }
    }
  }
}

.area {
  height: calc(100vh - 90px);

  .list {
    width: 779px;
    margin: 100px auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 18px 2px rgba(0, 0, 0, 0.04), 0px 2px 14px 0px rgba(0, 0, 0, 0.06), 0px 0px 11px 0px rgba(0, 0, 0, 0.08);
    border-radius: 18px;

    .list-head {
      padding: 0px 30px;
      border-bottom: 1px solid #D6D6D6;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 60px;
    }

    .list-box {
      padding: 0 60px 68px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .list-item {
        cursor: pointer;
        margin: 35px 19px 0 0;
        display: flex;
        flex-direction: column;
        width: 200px;
        height: 140px;
        background: #FFFFFF;
        border-radius: 6px;
        text-align: center;
        padding: 14px 0;
        box-shadow: 0px 0px 6px 0px rgba(42, 88, 253, 0.12);

        .img {
          width: 80px;
          margin: 0 auto;
        }

        .name {
          margin-top: 10px;
        }
      }

      .list-item:hover {
        box-shadow: 0px 0px 20px 0px rgba(55, 124, 253, 0.3);
      }
    }
  }

}

/deep/.el-dropdown-link {
  cursor: pointer !important;
}

/deep/.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background: #fafafc;
  color: #606266 !important;
}

/deep/.el-dropdown-menu li:hover {
  color: #606266 !important;
}</style>
